import { render, staticRenderFns } from "./CertificationTable.vue?vue&type=template&id=46526958&scoped=true"
import script from "./CertificationTable.vue?vue&type=script&lang=js"
export * from "./CertificationTable.vue?vue&type=script&lang=js"
import style0 from "./CertificationTable.vue?vue&type=style&index=0&id=46526958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46526958",
  null
  
)

export default component.exports